<script>
import { validateCategoryId } from '~/utils/common.js';

export default {
  nuxtI18n: {
    paths: {
      en: '/category/:id',
      de: '/category/:id',
      es: '/categoria/:id',
      pt: '/categoria/:id'
    }
  },
  async validate({ store, app: { $urlBuilder }, params, route, redirect }) {
    const id = params.id;
    await store.dispatch('categories/LOAD_CATEGORY', { id });

    const category = store.state.categories.category;
    return validateCategoryId(category, route.path, params, $urlBuilder, redirect);
  }
};
</script>
